import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = m[1];
    (async () => {
      try {
        await axios.get(`${API}/auth/google/callback?session_id=${encodeURIComponent(session_id)}`, { withCredentials: true });
        await refresh();
        window.history.replaceState(null, "", "/");
        nav("/");
      } catch { nav("/login"); }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0c0a09]" data-testid="auth-callback">
      <div className="text-stone-400 font-mono text-xs uppercase tracking-widest">Signing you in…</div>
    </div>
  );
}
